import { auth } from './firebase';

const API_BASE = (import.meta.env.VITE_ASSISTANT_API_BASE_URL || '').replace(/\/$/, '');

export interface ChatSource {
  title: string;
  reference: string | null;
}

export interface ChatResponse {
  conversationId: string;
  answer: string;
  sources: ChatSource[];
  raw: unknown;
}

export interface ChatErrorResponse {
  error: string;
  code?: string;
}

export async function sendChatMessage(
  message: string,
  conversationId: string | null
): Promise<ChatResponse> {
  const user = auth.currentUser;
  if (!user) throw new ChatApiError('Not authenticated', 401, 'UNAUTHORIZED');

  const idToken = await user.getIdToken();

  const body: Record<string, string> = { message };
  if (conversationId) {
    body.conversationId = conversationId;
  }

  const response = await fetch(`${API_BASE}/api/assistant/chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    let errorMessage = `Request failed: ${response.status}`;
    let code: string | undefined;

    try {
      const errorBody: ChatErrorResponse = await response.json();
      errorMessage = errorBody.error || errorMessage;
      code = errorBody.code;
    } catch {
      // Response body wasn't JSON
    }

    throw new ChatApiError(errorMessage, response.status, code);
  }

  return response.json();
}

export class ChatApiError extends Error {
  status: number;
  code?: string;

  constructor(message: string, status: number, code?: string) {
    super(message);
    this.name = 'ChatApiError';
    this.status = status;
    this.code = code;
  }
}
